import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { errorToast, successToast } from "../../Utils/utils";


export function createAnonymAccountWithCode(nickname:string, code:string, password:string, securityQuestion:number, answer:string, btn:JQuery|boolean=false){

    if (nickname == '' || nickname == undefined){
        errorToast("Bitte gib einen Namen an", "Fehler");
        return;
    }

    const url = '/register/anonym'

    const success = function (data){
        successToast("Dein Account wurde erstellt", "Erfolg", 4500);
                // Fill With Information!

                let html = '<div class="h2">Hallo ' + data.nickname +', dein Account wurde erstellt</div>' +
                    '<div class="mt-3 d-flex justify-content-center"><lottie-player src="https://assets8.lottiefiles.com/packages/lf20_ikihxv4x.json"  background="transparent"  speed="1"  style="width: 350px; height: 350px;" autoplay></lottie-player></div>' +
                    '<div class="text-muted mb-2">Bitte schreibe dir deine Einlog-Daten auf, da du keine neuen erhalten kannst, außer durch deine/-n Lehrer/-in und deine Sicherheitsfrage!</div>';
                html += '<div>Nutzername: <b>' + data.username + '</b></div>' +
                    '<div>Passwort: <b>Dein soeben festgelegtes Passwort</b></div>' +
                    '<div><button class="btn btn-light-info text-info" data-bs-toggle="modal" data-bs-target="#login-modal">Zur Anmeldung</button></div>';
                $("#redirection").val("home"); // set redirect
                $("#code-activation").html(html);
    }

    const data = {
        password: password,
        username: nickname,
        code: code,
        securityQuestion: securityQuestion,
        answer: answer,
    }

    return ajaxRequest(url, success, data, btn)

}
